export default "__VITE_ASSET__2X4DEUMR__"